module.exports = __webpack_public_path__ + "img/sa.340421d6.svg";